import Vue from '@/clir/main';
import App from './App.vue';
import store from '@/store';
import router from "@/router";

// Layouts :
import layouts from "@/layouts";
for (const layout of layouts) {
  Vue.component(`${layout}-layout`, () => import(`@/layouts/${layout}.vue`));
}

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app');